import { AHeading, BHeading } from '@Layouts/Ir/Heading'
import { Fragment } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Spacer } from '@/components/elements/Spacer'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'
import { PDFList } from '@/components/layouts/Ir/PDFList'

import { CompanyList, PublicNotice } from '@/types/publicNotice'

type Props = {
  company: CompanyList
  bulletin: PublicNotice[]
  finalAccount: PublicNotice[]
}

export const PublicNoticePDF = ({ company, bulletin, finalAccount }: Props) => {
  return (
    <>
      <AHeading>{company.companyName}</AHeading>
      {company.comments && <Paragraph>{company.comments}</Paragraph>}
      {company.showBulletin && (
        <section>
          <SubHeading>公告事項</SubHeading>
          <Spacer h={{ sp: 20, pc: 36 }} />
          {bulletin.length > 0 ? (
            <>
              <ItemContainer key={bulletin[0].type?.title ?? 'bulletin'}>
                <PDFList
                  pdfList={bulletin.map((item, index) => ({
                    id: `${item.pdf._id}${index}${item.company?._id}${item.index}${item.title}`,
                    fileName: item.title,
                    filePath: item.pdf.src,
                  }))}
                />
              </ItemContainer>
            </>
          ) : (
            <Paragraph>現在、公告すべき事項はございません。</Paragraph>
          )}
          <Spacer h={{ sp: 50, pc: 80 }} />
        </section>
      )}
      {company.showFinalAccounts && (
        <section>
          <SubHeading>決算公告</SubHeading>
          <Spacer h={{ sp: 20, pc: 36 }} />
          {company.finalAccountSummary && (
            <>
              <Paragraph>
                {company.finalAccountSummary.split('→').map((value, index) => (
                  <Fragment key={`${index}${value}`}>
                    {value}
                    <br />
                  </Fragment>
                ))}
              </Paragraph>
              <Spacer h={{ sp: 10, pc: 15 }} />
            </>
          )}
          {finalAccount.length > 0 ? (
            <>
              <ItemContainer
                key={finalAccount[0].type?.title ?? 'finalAccount'}
              >
                <PDFList
                  pdfList={finalAccount.map((item, index) => ({
                    id: `${item.pdf._id}${index}${item.company?._id}${item.index}${item.title}`,
                    fileName: item.title,
                    filePath: item.pdf.src,
                  }))}
                />
              </ItemContainer>
            </>
          ) : (
            <Paragraph>現在、決算公告事項はございません。</Paragraph>
          )}
          {company.finalAccountComments && (
            <>
              <Spacer h={{ sp: 10, pc: 15 }} />
              <Paragraph>
                {company.finalAccountComments.split('→').map((value, index) => (
                  <Fragment key={`${index}${value}`}>
                    {value}
                    <br />
                  </Fragment>
                ))}
              </Paragraph>
            </>
          )}
        </section>
      )}
    </>
  )
}

const SubHeading = styled(BHeading)`
  margin-top: 0;
  margin-bottom: 0;
`

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 25.6px;
  color: ${theme.colors.textTitle};

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 24px;
  }
`
